 
import { RecommendedNutrientQuantityData } from '../advice/models/fertilization-result.model';

export interface NutritionalCompositionData extends RecommendedNutrientQuantityData {
  n: number;
  p2O5: number;
  k2O: number;
  na2O: number;
  mgO: number;
  caO: number;
  sO3: number;
  b: number;
  mn: number;
  fe: number;
  zn: number;
  cu: number;
  co: number;
}

export enum StateOfMatterEnum {
  Solid = 'Solid',
  Liquid = 'Liquid',
}

export enum SkalTypeEnum {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum FertilizerTypeEnum {
  Synthetic = 'Synthetic',
  Animal = 'Animal',
  OtherOrganic = 'OtherOrganic',
  Compost = 'Compost',
  Lime = 'Lime',
  BioStimulator = 'BioStimulator',
}

export interface NitrogenEffectivenessData {
  january: number;
  february: number;
  march: number;
  april: number;
  may: number;
  june: number;
  july: number;
  august: number;
  september: number;
  october: number;
  november: number;
  december: number;
}

export interface FertilizerData {
  density: number;
  ediCode: number;
  fertilizerType: FertilizerTypeEnum;
  nutritionalComposition: NutritionalCompositionData;
  skalType: SkalTypeEnum;
  stateOfMatter: StateOfMatterEnum;
  nitrogenEffectiveness?: NitrogenEffectivenessData;
}

export interface CropProtectionData {
  activeIngredient: string;
  admissions: Admission[];
  admissionNumbers: string;
}

export enum ProductTypeEnum {
  GBM = 'GBM',
  Fertilizer = 'Fertilizer',
}

export enum UnitOfMeasurementEnum {
  G = 'G',
  KG = 'KG',
  T = 'Ton',
  ML = 'ML',
  L = 'L',
  ST = 'ST',
}

export interface CropAid {
  id: number;
  name: string;
  productType: ProductTypeEnum;
  unitOfMeasurement: UnitOfMeasurementEnum;
  indicativePrice: number;
  isActive: boolean;
  isCropProtection: boolean;
  isFertilizer: boolean;
  fertilizer?: FertilizerData;
  cropProtection?: CropProtectionData;
  forbiddenForPlanetProof: boolean;
  isHidden: boolean;
}

export interface CropAidState {
  genericCropAids?: CropAid[];
  proprietaryCropAids?: CropAid[];
  admissions?: Admission[];
}

export interface Admission {
  id: number;
  number: string;
  activeIngredients: AdmissionIngredient[];
}

export interface AdmissionIngredient {
  ingredientId: number;
  name: string;
  dosage: number;
}
